var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.984 32c-8.835-0.010-15.99-7.176-15.984-16.011 0.006-8.834 7.171-15.992 16.005-15.989 8.835 0.003 15.995 7.165 15.995 16-0.005 8.84-7.176 16.003-16.016 16zM3.2 16.275c0.036 3.383 1.41 6.613 3.822 8.986s5.664 3.694 9.046 3.676c3.383-0.018 6.621-1.375 9.006-3.773s3.725-5.644 3.725-9.027c0-3.383-1.339-6.628-3.725-9.027s-5.624-3.755-9.006-3.773c-3.383-0.018-6.635 1.303-9.046 3.676s-3.785 5.603-3.822 8.986v0.275zM17.6 24h-3.2v-3.2h3.2v3.2zM17.6 17.6h-3.2v-9.6h3.2v9.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorCircle);
export default __webpack_public_path__ + "static/media/icon-error-circle.3ea5139dade60d92b5bcd5f590b645d5.svg";
export { ForwardRef as ReactComponent };